import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M14.167 12.083V9.58c0-.15 0-.225-.023-.29a.4.4 0 0 0-.096-.156c-.05-.05-.116-.084-.25-.15L10 7.082m-6.667.834v5.672c0 .31 0 .465.049.6.042.12.112.229.203.318.104.1.244.165.526.294l5.333 2.444c.205.094.307.14.413.16q.143.024.286 0c.106-.02.208-.066.412-.16l5.334-2.444c.282-.13.422-.194.526-.294a.8.8 0 0 0 .203-.318c.049-.135.049-.29.049-.6V7.917m-15-.834 8.035-4.017c.11-.055.164-.082.221-.093q.077-.015.154 0c.057.01.112.038.221.093l8.035 4.017-8.035 4.018a1 1 0 0 1-.221.093.4.4 0 0 1-.154 0 1 1 0 0 1-.221-.093z"
    }, null, -1)
  ]))]))
}
export default { render: render }